import { Location as HistoryLocation } from "history";
import { AuthKeys } from "./common";

export const SSO_GW_KEYS = {
  KEY: "ssogw",
  UUID: "uuid",
} as const;

const hasLocationInformation = (
  target: unknown
): target is {
  pathname: string;
  search: string;
  hash: string;
} => {
  if (typeof target !== "object" || target === null) {
    return false;
  }

  const locationCandidate = target as Record<string, unknown>;

  return (
    "pathname" in locationCandidate &&
    "search" in locationCandidate &&
    "hash" in locationCandidate &&
    typeof locationCandidate.pathname === "string" &&
    typeof locationCandidate.search === "string" &&
    typeof locationCandidate.hash === "string"
  );
};

export const generatedRedirectUrl = (location: HistoryLocation<{ from?: Location }>, defaultRedirect = "/"): string => {
  const searchParam = new URLSearchParams(location.search);
  const redirectTo = searchParam.get("redirectTo");
  const from = location.state?.from;

  if (redirectTo) {
    return redirectTo;
  }

  if (hasLocationInformation(from)) {
    return `${from.pathname}${from.search}${from.hash}`;
  }

  return defaultRedirect;
};

export const generateSsoUrl = (ssoBaseUrl: string, authKeys: AuthKeys): string => {
  const { uuid, publicKey } = authKeys;
  const encodedPublicKey = encodeURIComponent(
    btoa(JSON.stringify({ redirect: window.location.href, [SSO_GW_KEYS.UUID]: uuid, key: publicKey }))
  );

  return `${ssoBaseUrl}/auth/sign-in/sso?${SSO_GW_KEYS.KEY}=${encodedPublicKey}`;
};

export const isInvalidTimeStamp = (timeStamp: number): boolean => {
  const OFFSET = 10 * 1000; // 10 Seconds

  const now = new Date().getTime();
  const prev = new Date(timeStamp + OFFSET).getTime();

  return now > prev;
};
